var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1768_2722",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 21,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H10C6.22901 4 4.34301 4 3.17201 5.172C2.32801 6.015 2.09201 7.229 2.02601 9.25H21.974C21.908 7.229 21.672 6.015 20.828 5.172C19.657 4 17.771 4 14 4ZM10 20H14C17.771 20 19.657 20 20.828 18.828C21.999 17.656 22 15.771 22 12C22 11.5587 21.9993 11.142 21.998 10.75H2.00201C2.00001 11.142 1.99934 11.5587 2.00001 12C2.00001 15.771 2.00001 17.657 3.17201 18.828C4.34401 19.999 6.22901 20 10 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 16C5.25 15.8011 5.32902 15.6103 5.46967 15.4697C5.61032 15.329 5.80109 15.25 6 15.25H10C10.1989 15.25 10.3897 15.329 10.5303 15.4697C10.671 15.6103 10.75 15.8011 10.75 16C10.75 16.1989 10.671 16.3897 10.5303 16.5303C10.3897 16.671 10.1989 16.75 10 16.75H6C5.80109 16.75 5.61032 16.671 5.46967 16.5303C5.32902 16.3897 5.25 16.1989 5.25 16ZM11.75 16C11.75 15.8011 11.829 15.6103 11.9697 15.4697C12.1103 15.329 12.3011 15.25 12.5 15.25H14C14.1989 15.25 14.3897 15.329 14.5303 15.4697C14.671 15.6103 14.75 15.8011 14.75 16C14.75 16.1989 14.671 16.3897 14.5303 16.5303C14.3897 16.671 14.1989 16.75 14 16.75H12.5C12.3011 16.75 12.1103 16.671 11.9697 16.5303C11.829 16.3897 11.75 16.1989 11.75 16Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1768_2722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.a1b0797878d58c3ff0a46c9d6d9fd5dd.svg";
export { ForwardRef as ReactComponent };